import { createFileRoute, Outlet } from '@tanstack/react-router';
import { PERMISSION_EXPENSE_TYPE } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import OperatingCostsTypes from '../../components/OperationCosts/OperatingCostsTypes';

export const Route = createFileRoute('/_authenticated/expense_types')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_EXPENSE_TYPE, ['read'], '/unauthorized', context);

    return {
      ...context,
      documentTitle: {
        main: 'menu.expenseTypesOverview',
        suffix: 'menu.costs',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: ExpenseTypesRoute,
});

function ExpenseTypesRoute() {
  return (
    <>
      {/* Always render the list */}
      <OperatingCostsTypes />
      {/* Outlet will render child routes (detail modal, etc.) on top */}
      <Outlet />
    </>
  );
}
